module.exports = __webpack_public_path__ + "img/alphabet-main-frame.1168281f.svg";